/**
 * Story Interlude Slider
 * Initializes Slick slider for story interlude blocks
 */

(function () {
  'use strict';

  var SLICK_RETRY_DELAY_MS = 100;
  var SLICK_MAX_RETRIES = 50;

  function initStoryInterludeSlider(attempt) {
    attempt = attempt || 0;

    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      if (attempt >= SLICK_MAX_RETRIES) {
        return;
      }
      setTimeout(function () {
        initStoryInterludeSlider(attempt + 1);
      }, SLICK_RETRY_DELAY_MS);
      return;
    }

    const $slider = jQuery('.js-story-interlude-slider');

    if ($slider.length === 0) {
      return;
    }

    // Only initialize slider below 1024px breakpoint
    function initSlider() {
      if (window.innerWidth < 1024) {
        // Initialize slider on mobile/tablet
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 560,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                }
              }
            ]
          });
        }
      } else {
        // Destroy slider on desktop (1024px and above)
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    // Initialize on load
    initSlider();

    // Re-initialize on resize (with debounce)
    let resizeTimer;
    jQuery(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initSlider();
      }, 250);
    });

    // Re-initialize on section load (for Theme Editor)
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId && jQuery(event.target).find('.js-story-interlude-slider').length > 0) {
        initSlider();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryInterludeSlider);
  } else {
    initStoryInterludeSlider();
  }
})();
